<template>
  <div
    class="as-stats-btn-list"
    :class="`as-stats-btn-list-${siteName}`"
  >
    <button class="as-stats-btn as-btn-target" type="button">
      <span class="as-target-home">{{ target ? target[0] : "_" }}</span>
      <IconTarget />
      <span class="as-target-away">{{ target ? target[1] : "_" }}</span>
    </button>
    <button class="as-stats-btn as-btn-corner" type="button">
      <span class="as-corner-home">{{
        homeScores.length > 0 ? homeScores[4] : "_"
      }}</span>
      <IconCornerNew fill_top="#5EB24A" fill_bottom="#FFB400" />
      <span class="as-corner-away">{{
        awayScores.length > 0 ? awayScores[4] : "_"
      }}</span>
    </button>
    <button class="as-stats-btn as-btn-yellow-card" type="button">
      <span class="as-yellow-card-home">{{
        homeScores.length > 0 ? homeScores[3] : "_"
      }}</span>
      <IconYellowCard />
      <span class="as-yellow-card-away">{{
        awayScores.length > 0 ? awayScores[3] : "_"
      }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import type { IMatch } from "~src/interfaces";
import IconTarget from "~src/components/icons/IconTarget.vue";
import IconCornerNew from "~src/components/icons/IconCornerNew.vue";
import IconYellowCard from "~src/components/icons/IconYellowCard.vue";
const commonStore = usecommonStore();

interface IProps {
  match: IMatch;
}

const props = withDefaults(defineProps<IProps>(), {});
const siteName = computed(() => commonStore.getSiteName);

const homeScores = computed(() => {
  return props.match.home_scores || [];
});

const awayScores = computed(() => {
  return props.match.away_scores || [];
});

const target = computed(() => {
  const halfTimeStatistics = props.match.half_time_statistics;
  if(halfTimeStatistics && halfTimeStatistics.ft && halfTimeStatistics.ft[21]) {
    return halfTimeStatistics.ft[21];
  }

  return null;
});
</script>

<script lang="ts">
export default {};
</script>
